import { useMutation } from "@tanstack/react-query";
import { searchArtists, searchGroups, ApiError } from "../api";
import { ArtistSearchResult, GroupSearchResponse } from "../api/types";

export function useArtistSearch() {
  return useMutation<
    ArtistSearchResult[],
    ApiError,
    { q: string; draftId?: string; limit?: number; offset?: number }
  >({
    mutationFn: (params) => searchArtists(params),
  });
}

export function useGroupSearch(draftId: string | undefined) {
  return useMutation<
    GroupSearchResponse,
    ApiError,
    { q: string; limit?: number; offset?: number }
  >({
    mutationFn: (params) => searchGroups({ ...params, draftId: draftId as string }),
  });
}
